import React, { useEffect, useState, useRef } from "react";
import styles from "./style.module.css";
import Header from "../../partials/ExternalHeader";
import CalDel from "../../../images/cal-del.png";
import Modal from "../../partials/Modal";
import { useSelector } from "react-redux";
import { loginSuccess } from "../../Redux/Authentication";
import { useNavigate, useParams } from "react-router-dom";
import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";
import { useDispatch } from "react-redux";
import { notification } from "antd";
import SendIcon from "../../../assets/icons/send_icon.svg";
import CrossIcon from "../../../assets/icons/cross_icon.svg";
import loaderIcon from "../../../assets/icons/Spinner-1s-200px.svg";
import "../Pickup/keyboard.css";
const url = process.env.REACT_APP_APP_BACK_URL;
const streaming_url = process.env.REACT_APP_STREAMIN_SOCKET_URL;
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
const Pin = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.user);
  let { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingScan, setIsLoadingScan] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [code, setCode] = useState("");
  const [pinKeyboardMode, setPinKeyboardMode] = useState("numeric");
  const pinAlphaLayout = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
    ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
    ["Z", "X", "C", "V", "B", "N", "M"],
    ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"],
    ["-", "_", "+", "=", "[", "]", "{", "}", "/", "\\"],
    [".", ",", ":", ";", "?", "'", "\"", "`", "~", "|"],
    ["<", ">"],
    ["Delete", "Space", "Clear", "Enter"],
  ];
  const [isFloating, setIsFloating] = useState(false);
  const [isCallFloating, setIsCallFloating] = useState(false);
  const [displayscaner, setdisplayscaner] = useState(true);
  const [modalIsOpen1, setIsOpen1] = useState(true);
  const [scannerInitialized, setScannerInitialized] = useState(false);
  const [authenticationFailed, setAuthenticationFailed] = useState(false);
  const [barcode, setBarcode] = useState("");
  const barcodeInputRef = useRef(null);
  const codeInputRef = useRef(null);
  useEffect(() => {
    let interval;
    const handleKeyDown = (evt) => {
      // Inputs on this page handle their own Enter; avoid double submits.
      if (evt.target && evt.target.tagName === "INPUT") return;
      if (interval) clearInterval(interval);
      if (evt.code === "Enter") {
        if (barcode) formSubmit1(barcode);
        setBarcode("");
        return;
      }
      // Only printable characters (ignore Tab, Control, CapsLock, ...).
      if (evt.key && evt.key.length === 1)
        setBarcode((prevBarcode) => prevBarcode + evt.key);
      interval = setInterval(() => setBarcode(""), 20);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [barcode]);
  const handleInput = (e) => {
    setCode((prevCode) => e.target.value);
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const scannerRef = useRef(null);

  // Function to handle scan button click
  const handleScanButtonClick = () => {
    setModalIsOpen(true);
    if (!scannerInitialized) {
      scannerRef.current = new Html5QrcodeScanner("reader", {
        qrbox: { width: 250, height: 250 },
        fps: 5,
      });
      scannerRef.current.render(handleScanSuccess, handleScanError);
      setScannerInitialized(true);
    }
  };

  // Function to close scanner modal
  const closeScanner = () => {
    if (scannerRef.current) {
      scannerRef.current.clear();
      scannerRef.current = null;
    }
    setScannerInitialized(false);
    setModalIsOpen(false);
  };

  // Success callback when QR code is scanned
  const handleScanSuccess = (result) => {

    if (scannerRef.current) {
      scannerRef.current.clear();
      scannerRef.current = null;
    }
    setScannerInitialized(false);
    setModalIsOpen(false);
    formSubmit1(result); // Replace with your form handling function
  };

  // Error callback for scanner
  const handleScanError = (err) => {
    console.warn("QR Scan Error:", err);
  };

  // React to authentication failure (if applicable)
  useEffect(() => {
    if (authenticationFailed) {
      setScannerInitialized(false);
      setAuthenticationFailed(false);
    }
  }, [authenticationFailed]);
  useEffect(() => {
    const focusInput = () => {
      if (barcodeInputRef.current) {
        barcodeInputRef.current.focus();
      }
    };

    focusInput();

    // Re-focus input if user taps anywhere
    document.addEventListener("click", focusInput);
    document.addEventListener("touchstart", focusInput);

    return () => {
      document.removeEventListener("click", focusInput);
      document.removeEventListener("touchstart", focusInput);
    };
  }, []);

  // Focus the visible code input field on mount
  useEffect(() => {
    if (codeInputRef.current) {
      codeInputRef.current.focus();
    }
  }, []);
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src =
  //     "https://cdn.jsdelivr.net/npm/rtsp-relay@1.7.0/browser/index.js";
  //   script.async = true;
  //   script.onload = () => {
  //     /* eslint-disable no-undef */
  //     loadPlayer({
  //       url: `${streaming_url}/stream/invid/url`, // Replace with your desired channel ID
  //       canvas: document.getElementById("canvas"),
  //     });
  //     /* eslint-enable no-undef */
  //   };
  //   document.head.appendChild(script);
  //   return () => {
  //     // Clean up the script element if the component unmounts
  //     document.head.removeChild(script);
  //   };
  // }, [streaming_url]);

  const handleDigitClick = (digit) => {
    setCode((prevCode) => prevCode + digit);
  };
  const handleDeleteDigit = () => {
    setCode((prevCode) => prevCode.slice(0, -1));
  };
  const handlePinKeyboardPress = (key) => {
    if (key === "Delete" || key === "Backspace") {
      setCode((prevCode) => prevCode.slice(0, -1));
    } else if (key === "Space") {
      setCode((prevCode) => prevCode + " ");
    } else if (key === "Clear") {
      setCode("");
    } else if (key === "Enter") {
      formSubmit();
    } else {
      setCode((prevCode) => prevCode + key);
    }
  };

  const barCodeSubmit = async (id) => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      setIsLoading(true);
      const response = await fetch(`${url}/api/sites/open/locker`, {
        mode: "cors",
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          name: id,
          slug: slug,
        }),
      });
      setIsLoading(false);
      const json = await response.json();
      if (json.success) {
        notification.success({
          message: "Success",
          description: json.message,
          duration: 3,
        });
        setTimeout(() => {
          navigate(`/${slug}/pickup/external/order/${json?.pickup?._id}`);
        }, 2000);
      } else {
        notification.error({
          message: "Errorr",
          description: json.message,
          duration: 3,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.error({
        message: "Errorr",
        description: error.message,
        duration: 3,
      });
    }
  };
  // Scanners can add control characters / whitespace around the payload.
  const cleanCode = (raw) =>
    String(raw || "")
      .replace(/[\u0000-\u001f\u007f]/g, "")
      .trim();
  const openMatchedLockerPage = async (enteredCode) => {
    try {
      const response = await fetch(`${url}/api/lockers/pin/match`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          code: cleanCode(enteredCode),
          slug,
        }),
      });
      const json = await response.json();
      if (json.codeKind === "universal") return json;
      if (json.success && json.locker?._id) {
        let opened = false;
        try {
          const openResponse = await fetch(
            `${url}/api/lockers/relay/state/update`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: json.locker._id, state: "2" }),
            }
          );
          const openJson = await openResponse.json();
          opened = !!openJson.success;
        } catch (error) {
          console.error(error);
        }
        navigate(`/${slug}/locker/open/${json.locker._id}`, {
          state: { opened, attempted: true },
        });
        return true;
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  };
  const isDepartmentCode = (payload) =>
    payload?.codeKind === "universal" ||
    /department universal code/i.test(String(payload?.error || ""));
  const openDepartmentCode = async (enteredCode) => {
    const response = await fetch(`${url}/api/department/universal`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: cleanCode(enteredCode), slug }),
    });
    const result = await response.json();
    const lockers = Array.isArray(result.lockers) ? result.lockers : [];
    if (!result.success || lockers.length === 0) {
      notification.error({
        message: "Unable to open locker",
        description:
          result.error && !/department screen/i.test(result.error)
            ? result.error
            : "No locker is assigned to this department code.",
        duration: 6,
      });
      return;
    }
    let opened = 0;
    for (const locker of lockers) {
      try {
        const openResponse = await fetch(
          `${url}/api/lockers/relay/state/update`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: locker._id, state: "2" }),
          }
        );
        const openJson = await openResponse.json();
        if (openJson.success) opened += 1;
      } catch (error) {
        console.error(error);
      }
    }
    if (!opened) {
      notification.error({
        message: "Unable to open locker",
        description: "The department code was verified, but the locker did not open.",
        duration: 6,
      });
      return;
    }
    const numbers = lockers.map((locker) => locker.number).filter(Boolean);
    notification.success({
      message: "Locker opened",
      description:
        numbers.length === 1
          ? `Locker #${numbers[0]} is open.`
          : `Lockers ${numbers.map((number) => `#${number}`).join(", ")} are open.`,
      duration: 4,
    });
    setCode("");
  };
  const submittingRef = useRef(false);
  // Single path for typed PINs and scanned QR/barcodes.
  const submitCode = async (rawCode) => {
    const enteredCode = cleanCode(rawCode);
    if (!enteredCode || submittingRef.current) return;
    submittingRef.current = true;
    setIsLoading(true);
    setIsLoadingScan(true);
    // PINs may contain any characters (e.g. "*$89791"): send exactly as scanned.
    const candidates = [enteredCode];
    let json = {};
    try {
      for (const candidate of candidates) {
        json = {};
        try {
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
          headers.append("auth-token", localStorage.getItem("token"));
          const query = JSON.stringify({
            code: candidate,
            slug: slug,
            lok3rOpen: true,
          });
          // Encode: scanned codes may contain / ? # % + which break the path.
          const response = await fetch(
            `${url}/api/pickups/code/${encodeURIComponent(query)}`,
            { mode: "cors", method: "GET", headers: headers }
          );
          json = await response.json();
        } catch (error) {
          // Non-JSON / failed lookup: still try the department code below.
          console.error(error);
        }
        if (isDepartmentCode(json)) {
          await openDepartmentCode(candidate);
          return;
        }
        if (json.success && json.pickup?._id) {
          navigate(
            `/${slug}/pickup/external/order/${json.pickup._id}?lockerOpen=true`
          );
          return;
        }
        const lockerResult = await openMatchedLockerPage(candidate);
        if (lockerResult === true) return;
        if (isDepartmentCode(lockerResult)) {
          await openDepartmentCode(candidate);
          return;
        }
      }
      const description =
        json.error ||
        json.message ||
        "We could not open the locker. Please try again.";
      notification.error({
        message: /pickup code|site address/i.test(description)
          ? "Invalid pickup code"
          : "Unable to open locker",
        description,
        duration: 6,
      });
    } finally {
      setIsLoading(false);
      setIsLoadingScan(false);
      submittingRef.current = false;
    }
  };
  const formSubmit1 = (qrCode) => submitCode(qrCode);
  const formSubmit = () => submitCode(code);
  const handleVideoClick = () => {
    const { width } = getWindowDimensions();
    const surfaceTabletWidth = 768;
    if (width < surfaceTabletWidth) {
      setIsFloating(!isFloating);
      setIsCallFloating(false);
    } else {
      setIsFloating(false);
    }
  };
  const handleButton1 = async () => {
    setdisplayscaner(true);
    setIsOpen1(true);
  };
  function closeModal() {
    setIsOpen1(false);
    setAuthenticationFailed(true);
  }
  const iocnStyle = {
    display: isLoading ? "inline-block" : "none",
  };
  const readerStyle = {
    position: "relative",
    marginTop: "20px",
    marginBottom: "20px",
    overflowY: "auto", // Enable scrolling if content exceeds height on large screens
  };
  if (isLoadingScan) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <img src={loaderIcon} alt="" />
      </div>
    );
  }

  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <>
      <div className={styles.heading}>
        <div className="body-wrap">
          <div className="container-fluid px-0">
            <Header />

            <div className=" d-flex justify-content-center  ">
              <div className="mt-5 mb-1 text-center ">
                {/* {isLoading ? (
                  <div className="text-center">
                    <h3>Loading....</h3>
                  </div>
                ) : (
                  displayscaner && (
                    <div
                      id="reader"
                      style={readerStyle}
                      className="render-class"
                    ></div>
                  )
                )} */}
                {/* {!modalIsOpen ? ( */}
                <img src="/arrow.png" height={70} width={70}   onError={(e) => {
                        e.target.src = "/placeholder.png";
                      }} />
                <br />
                <button
                  className="btn btn-prim w-auto py-3 mt-2"
                  // onClick={handleScanButtonClick}
                >
                  Scan QR Code
                </button>
                {/* //   ) : (

              //     <div className=" d-flex w-100 justify-content-center align-items-center">
              //       <button
              //         className="btn btn-prim w-auto py-3"
              //         onClick={closeScanner}
              //       >
              //         Close
              //       </button>
              //     </div>
              //   )} */}
                <h3 className="mt-2">OR</h3>
              </div>
            </div>
            <div className={styles.body_wrap}>
              <div className=" mt-1">
                <div className="calc-wrap-main">
                  <div className="row text-center">
                    <input
                      type="text"
                      ref={barcodeInputRef}
                      style={{
                        opacity: 0,
                        position: "absolute",
                        left: "-9999px",
                      }}
                      onChange={(e) => setBarcode(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          formSubmit1(e.target.value);
                          e.target.value = "";
                          setBarcode("");
                        }
                      }}
                      autoFocus
                    />
                    <div className="col-lg-12">
                      <div className="calc-wrap">
                        <div className="cal-screen">
                          <input
                            type="text"
                            id="result"
                            ref={codeInputRef}
                            onChange={handleInput}
                            value={code}
                            placeholder="Enter Pickup Code"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                formSubmit();
                              }
                            }}
                            autoComplete="off"
                            autoFocus
                          />
                        </div>
                        <div className="keys-wrap">
                          <div className="mb-2">
                            <button
                              type="button"
                              className="btn btn-prim w-auto"
                              onClick={() =>
                                setPinKeyboardMode((prevMode) =>
                                  prevMode === "numeric"
                                    ? "alphanumeric"
                                    : "numeric"
                                )
                              }
                            >
                              {pinKeyboardMode === "numeric"
                                ? "Use Letters & Symbols"
                                : "Use Numeric Keypad"}
                            </button>
                          </div>
                          {pinKeyboardMode === "numeric" ? (
                            <div className="row ">
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("1")}
                                >
                                  <i>1</i>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("2")}
                                >
                                  <i>2</i> <span>ABC</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("3")}
                                >
                                  <i>3</i> <span>DEF</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("4")}
                                >
                                  <i>4</i> <span>GHI</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("5")}
                                >
                                  <i>5</i> <span>JKL</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("6")}
                                >
                                  <i>6</i> <span>MNO</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("7")}
                                >
                                  <i>7</i> <span>PQRS</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("8")}
                                >
                                  <i>8</i> <span>TUV</span>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("9")}
                                >
                                  <i>9</i> <span>WXYZ</span>
                                </button>
                              </div>
                              <div className="col-8">
                                <button
                                  className="btn-key"
                                  onClick={() => handleDigitClick("0")}
                                >
                                  <i>0</i>
                                </button>
                              </div>
                              <div className="col-4">
                                <button
                                  className="btn-delt"
                                  onClick={handleDeleteDigit}
                                >
                                  <img src={CalDel} alt="" />{" "}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="order-alpha-keyboard">
                              {pinAlphaLayout.map((row, rowIndex) => (
                                <div
                                  key={rowIndex}
                                  className="order-alpha-keyboard-row"
                                >
                                  {row.map((key, index) => (
                                    <button
                                      key={index}
                                      type="button"
                                      onClick={() => handlePinKeyboardPress(key)}
                                      className={`order-alpha-key ${
                                        [
                                          "Delete",
                                          "Backspace",
                                          "Enter",
                                          "Space",
                                          "Clear",
                                        ].includes(key)
                                          ? "special"
                                          : ""
                                      }`}
                                    >
                                      {key}
                                    </button>
                                  ))}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="cont-btn-wrap">
                          <button
                            className="continue-btn"
                            disabled={isLoading}
                            onClick={formSubmit}
                          >
                            <i
                              className="fa fa-spinner fa-spin"
                              style={iocnStyle}
                            ></i>{" "}
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={modalIsOpen1}
          onClose={closeModal}
          className="d-flex flex-column justify-content-center p-3 col-lg-4 m-auto mt-3 h-100 align-items-center "
        >
          <div className="d-flex justify-content-between align-items-center flex-row">
            <img src={SendIcon} alt="send" height={40} width={40} />
            <img
              src={CrossIcon}
              alt="cross"
              onClick={closeModal}
              height={37}
              width={37}
            />
          </div>

          <div className="modal-body">
            <h1>tetetette</h1>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Pin;
